var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatternLiveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.877 10.7994H2.82231V15.6721H5.21508V14.6175H3.877V10.7994Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.91211 10.7977H6.9668V15.6736H5.91211V10.7977Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1777 14.6016H13.5823V13.7631H15.0601V12.7084H13.5823V11.8699H15.1777V10.8152H12.5276V15.6563H15.1777V14.6016Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.65139 10.7478L7.66579 11.1232L9.41759 15.7227L10.3059 15.7237L12.0429 11.1211L11.0561 10.7487L9.85947 13.9197L8.65139 10.7478Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87324 0.806005L3.19229 0.000610352C1.1636 1.71588 0.000106812 4.22186 0.000106812 6.87608H1.05479C1.05476 4.53288 2.08206 2.32043 3.87324 0.806005Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.17292 6.87601C3.17292 5.1575 3.92635 3.53486 5.24004 2.42417L4.5591 1.61877C3.0079 2.93031 2.11823 4.8465 2.11823 6.87604L3.17292 6.87601Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.29108 6.87601C5.29108 5.78223 5.77065 4.74945 6.60677 4.04242L5.9258 3.23706C4.85216 4.1449 4.2364 5.47124 4.2364 6.87601H5.29108Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9453 6.87602H18C18 4.2218 16.8365 1.71582 14.8078 0.000549316L14.1269 0.805944C15.918 2.3204 16.9453 4.53286 16.9453 6.87602Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8269 6.87598H15.8816C15.8816 4.84648 14.9919 2.93029 13.4407 1.61871L12.7598 2.42411C14.0734 3.53487 14.8269 5.15751 14.8269 6.87598Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7092 6.87607H13.7639C13.7639 5.4713 13.1482 4.14493 12.0745 3.23712L11.3936 4.04248C12.2297 4.74951 12.7092 5.78233 12.7092 6.87607Z",
  fill: "currentColor",
  fillOpacity: 0.65
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6454 6.88183C11.6454 5.42312 10.4587 4.23639 9 4.23639C7.5413 4.23639 6.35456 5.42312 6.35456 6.88183C6.35456 7.47829 6.55316 8.02908 6.88743 8.47205H0V17.9994H18V8.47205H11.1125C11.4468 8.02908 11.6454 7.47829 11.6454 6.88183ZM7.40925 6.88183C7.40925 6.00468 8.12285 5.29108 9 5.29108C9.87715 5.29108 10.5907 6.00468 10.5907 6.88183C10.5907 7.75237 9.88773 8.46147 9.01965 8.47205H8.98038C8.11227 8.46147 7.40925 7.75237 7.40925 6.88183ZM16.9453 16.9447H1.05469V9.52674H8.98038C8.98696 9.52677 8.99343 9.52723 9 9.52723C9.00657 9.52723 9.01304 9.52677 9.01962 9.52674H16.9453V16.9447Z",
  fill: "currentColor",
  fillOpacity: 0.65
})));
export default SvgPatternLiveIcon;